/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './medical-association.reducer';

export const MedicalAssociationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const medicalAssociationEntity = useAppSelector(state => state.medicalAssociation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="medicalAssociationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.medicalAssociation.detail.title">MedicalAssociation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.medicalAssociation.id">Id</Translate>
            </span>
          </dt>
          <dd>{medicalAssociationEntity.id}</dd>
          <dt>
            <span id="country">
              <Translate contentKey="tinyMedicRestApp.medicalAssociation.country">Country</Translate>
            </span>
          </dt>
          <dd>{medicalAssociationEntity.country}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.medicalAssociation.name">Name</Translate>
            </span>
          </dt>
          <dd>{medicalAssociationEntity.name}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.medicalAssociation.active">Active</Translate>
            </span>
          </dt>
          <dd>{medicalAssociationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.medicalAssociation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{medicalAssociationEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.medicalAssociation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{medicalAssociationEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.medicalAssociation.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{medicalAssociationEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.medicalAssociation.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{medicalAssociationEntity.lastupdated}</dd>
          <dt>
            <span id="regAuth">
              <Translate contentKey="tinyMedicRestApp.medicalAssociation.regAuth">Reg Auth</Translate>
            </span>
          </dt>
          <dd>{medicalAssociationEntity.regAuth ? 'true' : 'false'}</dd>
        </dl>
        <Button tag={Link} to="/medical-association" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/medical-association/${medicalAssociationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MedicalAssociationDetail;
